const Course = {

    // FIELDS
    "name": "Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "course": "Course",

    // ERROR
    "error_name": "Enter Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'COURSE NAME',
    "table_status": "STATUS",

}

export default Course;